// src/utils/telegram.js

export const ALLOWED_USER_IDS = [455762771] // здесь твои Telegram user.id

export function getTg() {
    if (typeof window === 'undefined') return null
    return window.Telegram && window.Telegram.WebApp ? window.Telegram.WebApp : null
}

export function getTgUserId() {
    let uid = null

    if (process.env.NODE_ENV === 'development') {
        const params = new URLSearchParams(window.location.search)
        const mock = params.get('uid')
        uid = mock ? Number(mock) : 123456789
    } else {
        const tg = getTg()
        uid =
            tg && tg.initDataUnsafe && tg.initDataUnsafe.user
                ? Number(tg.initDataUnsafe.user.id)
                : null
    }

    return Number.isFinite(uid) ? uid : null
}
export function isUserAdmin() {
    const uid = getTgUserId()
    if (process.env.NODE_ENV === 'development') {
        if (uid === 123456789){
            return true
        }
    }else{
        return uid ? ALLOWED_USER_IDS.includes(uid) : false
    }
}

export function safeAlert(message) {
    const tg = getTg()
    if (tg?.showAlert && typeof tg.showAlert === 'function') {
        try {
            tg.showAlert(message)
        } catch (e) {
            alert(message)
        }
    } else {
        alert(message)
    }
}